module.exports = __webpack_public_path__ + "static/media/поверх домов.a57be1bb.png";